export default __webpack_public_path__ + "static/logo_UE-6584c039c8e26224d08540d5eeea8725.png";